// material-ui
import {
	amber,
	blue,
	blueGrey,
	brown,
	common,
	cyan,
	deepOrange,
	deepPurple,
	green,
	grey,
	indigo,
	lightBlue,
	lightGreen,
	lime,
	orange,
	pink,
	purple,
	red,
	teal,
	yellow
} from '@mui/material/colors';
import { createTheme } from '@mui/material/styles'

// project import
import ThemeOption from './theme/index.jsx'

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
	const colors = {
		red,
		pink,
		purple,
		deepPurple,
		indigo,
		blue,
		lightBlue,
		cyan,
		teal,
		green,
		lightGreen,
		lime,
		yellow,
		amber,
		orange,
		deepOrange,
		brown,
		grey,
		blueGrey,
		common
	}
	
	const paletteColor = ThemeOption(colors, presetColor, mode)
	
	return createTheme({
		palette: {
			mode,
			...paletteColor,
		}
	})
}
